import { DataService } from './dataService'
export const seaConsolidationServices = {
	add_cons_seafreightrats: async (data) => {
		return DataService.post('/admin/add_cons_seafreightrats', data)
	},

	update_cons_seafreightrats: async (data) => {
		return DataService.post('/admin/update_cons_seafreightrats' ,data)
	},

    update_cons_seafreightrats_status: async (data) => {
        return DataService.post('/admin/update_cons_seafreightrats_status' ,data)
    },

    get_cons_seafreightrats: async (data) => {
		return DataService.get('/admin/get_cons_seafreightrats', data)
	},

	import_seafreights_cons_data: async (data) => {
        return DataService.post('/admin/import_seafreights_cons_data' ,data)
    },

    export_seafreights_cons_data: async (data) => {
		return DataService.get('/admin/export_seafreights_cons_data', data)
	},

}